import BaseService from './BaseService';
import IStoryletService, {
  IAddNewContactData,
  IApiStoryletResponseData,
  IChooseBranchRequestData,
} from 'types/storylet/service';

export default class StoryletService extends BaseService implements IStoryletService {
  /**
   * Fetch
   * @return {Promise}
   */
  fetchAvailable = () => {
    const config = {
      method: 'post',
      url: '/storylet',
    };
    return (this.doRequest<IApiStoryletResponseData>(config));
  };

  /**
   * Begin
   * @param  {Number} eventId
   * @return {Promise}
   */
  begin = (eventId: number) => {
    const config = {
      data: { eventId },
      method: 'post',
      url: '/storylet/begin',
    };
    return this.doRequest<IApiStoryletResponseData>(config);
  };

  /**
   * Go back
   * @return {Promise} [description]
   */
  goBack = () => {
    const config = {
      method: 'post',
      url: '/storylet/goback',
    };
    return this.doRequest(config);
  };


  /**
   * Choose Branch
   * @return {Promise}
   */
  chooseBranch = (data: IChooseBranchRequestData) => {
    const config = {
      method: 'post',
      url: '/storylet/choosebranch',
      data: {
        branchId: data.branchId,
        secondChanceIds: data.secondChanceIds,
      },
    };
    return this.doRequest(config);
  };


  /**
   * Send a social invite
   * @param  {Object} data
   * @return {Promise}
   */
  sendSocialInvite = (data: any) => {
    const config = {
      method: 'post',
      url: '/storylet/sendinternalsocialact',
      data: {
        userMessage: data.messageInput,
        branchId: data.branchId,
        targetCharacterId: data.targetCharacterId,
      },
    };
    return this.doRequest(config);
  };


  /**
   * Send a social invite
   * @param  {Object} data
   * @return {Promise}
   */
  sendExternalSocialInvite = (data: any) => {
    const config = {
      method: 'post',
      url: '/storylet/sendexternalsocialact',
      data,
    };
    return this.doRequest(config);
  };

  /**
   * Fetch Ineligible Contacts
   * @return {Promise}
   * @param branchId
   */
  fetchIneligibleContacts = (branchId: number) => {
    const config = {
      method: 'post',
      url: '/storylet/ineligiblecontacts',
      data: { branchId }
    };
    return this.doRequest(config);
  };


  /**
   * Add new contact
   * @param {undefined} data
   */
  addNewContact = (data: IAddNewContactData) => {
    const config = {
      method: 'post',
      url: `/storylet/addcontact`,
      data: {
        branchId: data.branchId,
        username: data.username
      }
    };
    return this.doRequest(config);
  };


  /**
   * Rename Quality
   * @param  {Object} data
   * @return {Promise}
   */
  renameQuality = (data: any) => {
    const config = {
      method: 'post',
      url: '/storylet/renamequality',
      data: {
        branchId: data.branchId,
        qualityPossessedId: data.qualityPossessedId,
        name: data.name,
      },
    };
    return this.doRequest(config);
  };


  /**
   * Begin Socail Event
   * @return {Promise}
   * @param invitationId
   */
  beginSocialEvent = (invitationId: number) => {
    const config = {
      method: 'post',
      url: `/storylet/beginsocialevent/${invitationId}`,
    };
    return this.doRequest(config);
  };

  suggestContact = (branchId: number) => {
    const config = {
      method: 'get',
      url: `/storylet/suggest?branchid=${branchId}`,
    };
    return this.doRequest(config);
  };

  /**
   * Begin
   * @param  {Number} qualityId
   * @return {Promise}
   */
  useQuality = (qualityId: number) => {
    const config = {
      method: 'post',
      url: '/storylet/usequality',
      data: { qualityId }
    };
    return this.doRequest(config);
  };
}
